import {combineReducers} from 'redux'
import {LINKS_LOADED, TICKET_CLAIM_STREAM_LOADED, TICKET_CLAIM_STREAM_QUERIED, TICKET_CLAIM_LOADED, TICKET_CLAIM_CREATED} from './actions'
import {OPEN_TICKET_CLAIM_CMD_UPDATED, QUALIFY_TICKET_CLAIM_CMD_UPDATED, ANSWER_TICKET_CLAIM_CMD_UPDATED, CHALLENGE_TICKET_CLAIM_CMD_UPDATED, ANSWER_CHALLENGE_TICKET_CLAIM_CMD_UPDATED} from './actions'
import {OPEN_TICKET_CLAIM_CMD_SENT, QUALIFY_TICKET_CLAIM_CMD_SENT, ANSWER_TICKET_CLAIM_CMD_SENT, CHALLENGE_TICKET_CLAIM_CMD_SENT, ANSWER_CHALLENGE_TICKET_CLAIM_CMD_SENT} from './actions'

function ticketClaim(state = null, action) {
    switch (action.type) {
        case TICKET_CLAIM_LOADED:
            return action.ticketClaim
        case TICKET_CLAIM_CREATED:
            return action.ticketClaim
        default:
            return state
    }
}

function stream(state = [], action) {
    switch (action.type) {
      case TICKET_CLAIM_STREAM_LOADED:
      case TICKET_CLAIM_STREAM_QUERIED:
          return action.stream
      default:
          return state
    }
}

function range(state = null, action) {
    switch (action.type) {
      case TICKET_CLAIM_STREAM_LOADED:
      case TICKET_CLAIM_STREAM_QUERIED:
          return action.range
      default:
          return state
    }
}

function query(state = null, action) {
    switch (action.type) {
        case TICKET_CLAIM_STREAM_LOADED:
        case TICKET_CLAIM_STREAM_QUERIED:
            return action.query
        default:
            return state
    }
}

function _links(state = [], action) {
    switch (action.type) {
        case TICKET_CLAIM_STREAM_LOADED:
        case TICKET_CLAIM_STREAM_QUERIED:
        case LINKS_LOADED:
            return action._links
        default:
            return state
    }
}

function openTicketClaimCmd(state = null, action) {
    switch (action.type) {
        case OPEN_TICKET_CLAIM_CMD_UPDATED:
            return {...state, ...action.cmd}
        case OPEN_TICKET_CLAIM_CMD_SENT:
            return null
        default:
            return state
    }
}

function qualifyTicketClaimCmd(state = null, action) {
    switch (action.type) {
        case QUALIFY_TICKET_CLAIM_CMD_UPDATED:
            return {...state, ...action.cmd}
        case QUALIFY_TICKET_CLAIM_CMD_SENT:
            return null
        default:
            return state
    }
}

function answerTicketClaimCmd(state = null, action) {
    switch (action.type) {
        case ANSWER_TICKET_CLAIM_CMD_UPDATED:
            return {...state, ...action.cmd}
        case ANSWER_TICKET_CLAIM_CMD_SENT:
            return null
        default:
            return state
    }
}

function challengeTicketClaimCmd(state = null, action) {
    switch (action.type) {
        case CHALLENGE_TICKET_CLAIM_CMD_UPDATED:
            return {...state, ...action.cmd}
        case CHALLENGE_TICKET_CLAIM_CMD_SENT:
            return null
        default:
            return state
    }
}

function answerChallengeTicketClaimCmd(state = null, action) {
    switch (action.type) {
        case ANSWER_CHALLENGE_TICKET_CLAIM_CMD_UPDATED:
            return {...state, ...action.cmd}
        case ANSWER_CHALLENGE_TICKET_CLAIM_CMD_SENT:
            return null
        default:
            return state
    }
}

export default combineReducers({
    ticketClaim,
    stream,
    range,
    query,
    _links,
    openTicketClaimCmd,
    qualifyTicketClaimCmd,
    answerTicketClaimCmd,
    challengeTicketClaimCmd,
    answerChallengeTicketClaimCmd
})


// WEBPACK FOOTER //
// ./lib/claim/reducers.js